export const REPLY_SUGGESTIONS_GIF =
  'https://cdn.livechat-static.com/api/file/lc/img/default/assets/reply-suggestions-chat-tour.gif';

export const TAGS_PNG = 'https://cdn.livechat-static.com/api/file/lc/img/default/assets/tags-tour.png';
